var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#3A3A3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.375 24.358a6.134 6.134 0 0 1 2.926-5.148 6.293 6.293 0 0 0-4.956-2.675c-2.085-.218-4.107 1.246-5.17 1.246-1.082 0-2.718-1.224-4.48-1.188a6.602 6.602 0 0 0-5.555 3.382c-2.401 4.152-.61 10.254 1.69 13.61 1.152 1.643 2.497 3.478 4.257 3.413 1.723-.071 2.366-1.096 4.445-1.096 2.06 0 2.663 1.096 4.46 1.055 1.847-.03 3.012-1.65 4.122-3.31A13.585 13.585 0 0 0 35 29.814a5.93 5.93 0 0 1-3.625-5.454zm-3.392-10.03A6.036 6.036 0 0 0 29.367 10a6.16 6.16 0 0 0-3.983 2.058 5.743 5.743 0 0 0-1.42 4.168 5.093 5.093 0 0 0 4.019-1.898z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkAppStore);
export default __webpack_public_path__ + "static/media/darkAppStore.58a73c55934b17698136d2b816301dae.svg";
export { ForwardRef as ReactComponent };